import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Footer.css";
import FooterLogo from "../assets/logo/Footer.svg";
import { useContactModal } from "../context/ContactContext";

const Footer = () => {
  const { openContactModal } = useContactModal();
  const navigate = useNavigate();
  const location = useLocation();

  const handleDealsClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      const el = document.getElementById("pricing");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById("pricing");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Upper Content - 5 Columns */}
        <div className="upper-content">
          <div className="footer-description">
            <p>
              We Design And Develop Premium, Luxury Websites That Elevate
              Brands, Engage Users, And Drive Measurable Growth. Built With
              Strategy, Crafted With Precision.
            </p>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <button
              type="button"
              className="footer-contact-link"
              onClick={openContactModal}
              style={{
                background: "none",
                border: "none",
                color: "inherit",
                font: "inherit",
                padding: 0,
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              Contact Us
            </button>
            <a href="#pricing" onClick={handleDealsClick}>
              Our Deals
            </a>
          </div>

          <div className="footer-column">
            <h4>Services</h4>
            <span>AI Development</span>
            <span>UI/UX Design</span>
            <span>Website Design + Development </span>
            <span>WordPress Development</span>
            <span>Webflow Development</span>
            <span>Shopify Development</span>
            <span>Wix Website Development</span>
            <span>Web App Development</span>
            <span>Mobile App Development</span>
            <span>Luxury Business Websites</span>
          </div>

          <div className="footer-column">
            <h4>Whatsapp</h4>
            <a
              href="https://wa.me/message/OOUUDN6E2OE5B1"
              target="_blank"
              rel="noopener noreferrer"
            >
              +1 (971) 668-2441
            </a>
            <h4>Email Us</h4>
            <a href="mailto:hello@metatrybe.com">hello@metatrybe.com</a>
            <a href="mailto:info@metatrybe.com">Support@metatrybe.com</a>
            <h4>Address</h4>
            <p>1272 S Governors Ave<br />
              Unit #2005<br />
              Dover, DE 19904</p>
          </div>
      
          <div className="footer-column">
            <h4>Follow</h4>
            <a href="#">Linkedin</a>
            <a href="#">Instagram</a>
          </div>
        </div>

        {/* Logo Section */}
        <div className="footer-logo-section">
          <img src={FooterLogo} alt="" />
        </div>

        {/* Lower Content - Copyright & Links */}
        <div className="lower-content">
          <p className="copyright">© 2026 Metatrybe. All Rights Reserved.</p>
          <div className="legal-links">
            <a href="#">Terms Of Use</a>
            <a href="#">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
